var _dec, _class, _PausedCaptureOverlay, _IconPauseLine;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyle, jsx } from '@instructure/emotion';
import { IconPauseLine } from '@instructure/ui-icons';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { translate } from '../../../constants/translated/translations';
import { formatCaptureTime } from '../../../utils/index';

/**
---
private: true
---
**/
let PausedCaptureOverlay = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_PausedCaptureOverlay = class PausedCaptureOverlay extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.props.makeStyles();
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  render() {
    const styles = this.props.styles;
    return jsx("div", {
      css: styles.container
    }, jsx("div", {
      css: styles.inner
    }, jsx("div", {
      css: styles.pauseIcon
    }, _IconPauseLine || (_IconPauseLine = jsx(IconPauseLine, {
      size: "large"
    }))), jsx("div", null, `${translate('PAUSED_VIDEO')} (${formatCaptureTime(this.props.timeElapsed)})`)));
  }
}, _PausedCaptureOverlay.propTypes = {
  // eslint-disable-next-line react/require-default-props
  makeStyles: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object,
  timeElapsed: PropTypes.number.isRequired
}, _PausedCaptureOverlay)) || _class);
const mapStateToProps = state => ({
  timeElapsed: state.timeElapsed
});
export default connect(mapStateToProps)(PausedCaptureOverlay);